import { render, staticRenderFns } from "./FromNow.vue?vue&type=template&id=0c3c5806&lang=pug&"
import script from "./FromNow.vue?vue&type=script&lang=js&"
export * from "./FromNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FromNow.vue"
export default component.exports